/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalnav_BriefsInputs */

const en_portalnav_briefs = /** @type {(inputs: Portalnav_BriefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Briefs`)
};

/** @type {(inputs: Portalnav_BriefsInputs) => LocalizedString} */
const ar_portalnav_briefs = en_portalnav_briefs;

/** @type {(inputs: Portalnav_BriefsInputs) => LocalizedString} */
const he_portalnav_briefs = en_portalnav_briefs;

/** @type {(inputs: Portalnav_BriefsInputs) => LocalizedString} */
const ur_portalnav_briefs = en_portalnav_briefs;

/** @type {(inputs: Portalnav_BriefsInputs) => LocalizedString} */
const es_portalnav_briefs = en_portalnav_briefs;

/** @type {(inputs: Portalnav_BriefsInputs) => LocalizedString} */
const fr_portalnav_briefs = en_portalnav_briefs;

/** @type {(inputs: Portalnav_BriefsInputs) => LocalizedString} */
const de_portalnav_briefs = en_portalnav_briefs;

/** @type {(inputs: Portalnav_BriefsInputs) => LocalizedString} */
const pt_portalnav_briefs = en_portalnav_briefs;

/** @type {(inputs: Portalnav_BriefsInputs) => LocalizedString} */
const hi_portalnav_briefs = en_portalnav_briefs;

/** @type {(inputs: Portalnav_BriefsInputs) => LocalizedString} */
const bn_portalnav_briefs = en_portalnav_briefs;

/**
* | output |
* | --- |
* | "Briefs" |
*
* @param {Portalnav_BriefsInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalnav_briefs = /** @type {((inputs?: Portalnav_BriefsInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalnav_BriefsInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalnav_briefs(inputs)
	if (locale === "he") return he_portalnav_briefs(inputs)
	if (locale === "ur") return ur_portalnav_briefs(inputs)
	if (locale === "es") return es_portalnav_briefs(inputs)
	if (locale === "fr") return fr_portalnav_briefs(inputs)
	if (locale === "de") return de_portalnav_briefs(inputs)
	if (locale === "pt") return pt_portalnav_briefs(inputs)
	if (locale === "hi") return hi_portalnav_briefs(inputs)
	if (locale === "bn") return bn_portalnav_briefs(inputs)
	return /** @type {LocalizedString} */ ("Briefs")
});